import { useTranslation } from 'react-i18next'

import DataBlock from '@/components/DataBlock/DataBlock'
import AvailabilityBadge from '@/components/common/AvailabilityBadge/AvailabilityBadge'
import { type DayOfWeek, daysOfWeek } from '@/constants/days-of-week'
import { getWeekDays } from '@/utils/format-date'

import styles from './AvailabilityDataBlock.module.scss'
import type { AvailabilitySlot } from '../queries/useUserAvailability'

export type AvailabilityDataBlockProps = {
  availability?: Record<DayOfWeek, AvailabilitySlot[]>
}

const AvailabilityDataBlock = (props: AvailabilityDataBlockProps) => {
  const weekdays = getWeekDays()

  const scheduleInfo = daysOfWeek.map((day, index) => ({
    label: weekdays[index],
    value: <AvailabilityValue slots={props.availability?.[day]} />
  }))

  return <DataBlock infoArray={scheduleInfo} />
}

const AvailabilityValue = (props: { slots?: AvailabilitySlot[] }) => {
  const { t } = useTranslation('common')

  if (!props.slots?.length) {
    return (
      <span className={styles.availabilitySlot}>
        <AvailabilityBadge variant="unavailable" />
        <span className={styles.availabilityText}>
          {t('label.unavailable')}
        </span>
      </span>
    )
  }

  return (
    <div className={styles.availabilityContainer}>
      {props.slots.map(item => (
        <span key={item.id} className={styles.availabilitySlot}>
          <AvailabilityBadge
            variant={item.isOptional ? 'optional' : 'available'}
          />
          <span className={styles.availabilityText}>
            {item.startTime} - {item.endTime}
          </span>
        </span>
      ))}
    </div>
  )
}

export default AvailabilityDataBlock
